.container {
  width: 37.5rem;
}
